import Hidden from "@material-ui/core/Hidden";
import React, { useState } from "react";
import Footer from "../components/Footer";
import { MainHeader } from "../components/MainHeader";
import { NavigationDrawer } from "../components/NavigationDrawer";
import { Downloads } from "../components/Downloads";
import TryBlackvue from "../components/TryBlackvue";
import { useHistory } from "react-router-dom";
import withSimpleBar from "../hoc/withSimpleBar";

export const DownloadsScreen = withSimpleBar(() => {
  const [value] = useState<number>(0);
  const [openDrawer, setOpenDrawer] = useState(false);
  const history = useHistory();

  const handleClickMenu = () => {
    setOpenDrawer((open) => !open);
  };

  const handleClickPricing = () => {
    history.push("/pricing");
    setOpenDrawer(false);
  };

  return (
    <React.Fragment>
      <MainHeader value={value} color="default" onClickMenu={handleClickMenu} />
      <Downloads />
      <TryBlackvue />
      <Footer />
      <Hidden mdUp>
        <NavigationDrawer
          open={openDrawer}
          onOpen={() => setOpenDrawer(true)}
          onClose={() => setOpenDrawer(false)}
          onClickCloud={() => setOpenDrawer(false)}
          onClickFleet={() => setOpenDrawer(false)}
          onClickPricing={handleClickPricing}
        />
      </Hidden>
    </React.Fragment>
  );
});
